import { __require as e } from "./Address.mjs";
var r, s;
function t() {
  if (s) return r;
  s = 1;
  const t = e();
  return r = class {
    constructor({
      meta: e,
      addresses: r
    }) {
      this.meta = {
        lines: e.lines,
        unicode: e.unicode,
        addressCount: e.address_count,
        verifiedCount: e.verified_count,
        bytes: e.bytes,
        characterCount: e.character_count
      }, this.addresses = r.map(e => new t(e));
    }
  };
}
export { t as __require };